import { render, staticRenderFns } from "./OccurrenceTable.vue?vue&type=template&id=2e1a7403&scoped=true&"
import script from "./OccurrenceTable.vue?vue&type=script&lang=js&"
export * from "./OccurrenceTable.vue?vue&type=script&lang=js&"
import style0 from "./OccurrenceTable.vue?vue&type=style&index=0&id=2e1a7403&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1a7403",
  null
  
)

export default component.exports